/**
 * External dependencies
 */
import clsx from 'clsx';

/**
 * WordPress dependencies
 */
import {
	ToggleGroupControl,
	ToggleGroupControlOptionIcon,
} from '@safe-wordpress/components';
import {
	reset,
	formatStrikethrough,
	formatUnderline,
} from '@safe-wordpress/icons';
import { _x } from '@safe-wordpress/i18n';

const TEXT_DECORATIONS = [
	{
		label: _x( 'None', 'text', 'nelio-ab-testing' ),
		value: 'none',
		icon: reset,
	},
	{
		label: _x( 'Underline', 'text', 'nelio-ab-testing' ),
		value: 'underline',
		icon: formatUnderline,
	},
	{
		label: _x( 'Strikethrough', 'text', 'nelio-ab-testing' ),
		value: 'line-through',
		icon: formatStrikethrough,
	},
];

/**
 * Control to facilitate text decoration selections.
 *
 * @param {Object}   props           Component props.
 * @param {string}   props.value     Currently selected text decoration.
 * @param {Function} props.onChange  Handles change in text decoration selection.
 * @param {string}   props.className Additional class name to apply.
 *
 * @return {Element} Text decoration control.
 */
type TextDecorationControlProps = {
	readonly className?: string;
	readonly value?: string;
	readonly onChange: ( value?: string | number ) => void;
	readonly disabled?: boolean;
};
export function TextDecorationControl( {
	value,
	className,
	disabled,
	onChange,
}: TextDecorationControlProps ): JSX.Element {
	return (
		<ToggleGroupControl
			isDeselectable
			__nextHasNoMarginBottom
			__next40pxDefaultSize
			label={ _x( 'Decoration', 'text', 'nelio-ab-testing' ) }
			className={ clsx(
				'block-editor-text-decoration-control',
				className
			) }
			value={ value }
			onChange={ ( newValue ) => {
				onChange( newValue === value ? undefined : newValue );
			} }
		>
			{ TEXT_DECORATIONS.map( ( option ) => {
				return (
					<ToggleGroupControlOptionIcon
						key={ option.value }
						value={ option.value }
						icon={ option.icon }
						label={ option.label }
						disabled={ disabled }
					/>
				);
			} ) }
		</ToggleGroupControl>
	);
}
